import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import ExpandableSection from '../ExpandableSection'
import getField from '../../utilities/Data/getField'
import Collection from '../Collection'
import styles from './Kit.icss'
import LoadingInline from '../LoadingInline'
import urlForKit from '../../utilities/urlForKit'
import urlForItem from '../../utilities/urlForItem'
import Thing from '../../utilities/Data/Thing'
import mergeThings from '../../utilities/Data/mergeThings'
import entityTypes from '../../enums/entityTypes'

class UserKit extends React.Component {
	render() {
		const { userProfile, isOwnProfile, userProfileKits, userProfileKitsOwned, userProfileKitsWanted, userProfileItemsOwned, userProfileItemsWanted } = this.props

		const openKit = kit => this.props.appRedirect(urlForKit(kit))
		const openItem = item => this.props.appRedirect(urlForItem(item))
		const openSearch = () => this.props.appRedirect('/search')
		const doNotOwnKit = kit => this.props.kitOwnSet({ own: false, kit })
		const doNotWantKit = kit => this.props.kitWantSet({ want: false, kit })
		// TODO: ownwant
		const doNotOwnItem = item => this.props.itemOwnSet({ own: false, item })
		const doNotWantItem = item => this.props.itemWantSet({ want: false, item })
		const duplicateKit = kit => this.props.kitDuplicate({ kitId: kit.kitId })
		const editKit = kit => this.props.appRedirect(`/kit/edit/${kit.kitId}`)
		// would some of this async saga stuff be better done as a function? if its stuff that the user should not be able to modify then yes.
		const deleteKit = kit => this.props.kitDelete({ kitId: kit.kitId }) // this is the setting of the soft delete flag, delete and cleanup is in a function

		const thingIconName = Thing.propertyGetter({
			[entityTypes.KIT.type]: 'blackKit'
		})
		const openThing = Thing.propertyGetter({
			[entityTypes.ITEM.type]: openItem,
			[entityTypes.KIT.type]: openKit
		})
		const doNotOwnThing = Thing.propertyGetter({
			[entityTypes.ITEM.type]: doNotOwnItem,
			[entityTypes.KIT.type]: doNotOwnKit
		})
		const doNotWantThing = Thing.propertyGetter({
			[entityTypes.ITEM.type]: doNotWantItem,
			[entityTypes.KIT.type]: doNotWantKit
		})

		const sortThings = things => things.sort((a, b) => {
			const getMillis = value => ((value.modifiedTimestamp || value.createdTimestamp) || { toMillis: () => 0 }).toMillis()
			const valueA = getMillis(a)
			const valueB = getMillis(b)
			return valueA - valueB
		})
		const mergeAndSortThings = (...thingArrays) => sortThings(mergeThings(...thingArrays))

		const loadedKits = !!userProfileKits
		const loadedOwnedThings = !!userProfileItemsOwned && !!userProfileKitsOwned
		const loadedWantedThings = !!userProfileItemsWanted && !!userProfileKitsWanted
		const ownedThings = (loadedOwnedThings && mergeAndSortThings(userProfileItemsOwned, userProfileKitsOwned)) || undefined
		const wantedThings = (loadedWantedThings && mergeAndSortThings(userProfileItemsWanted, userProfileKitsWanted)) || undefined

		const contextMenuItems = (thing, { isCreator, isOwned, isWanted }) => [
			Thing.isKit(thing) && {
				name: this.context.translate('Duplicate'),
				handler: duplicateKit
			},
			isOwnProfile && isOwned && {
				name: this.context.translate('Do not own'),
				handler: doNotOwnThing
			},
			isOwnProfile && isWanted && {
				name: this.context.translate('Do not want'),
				handler: doNotWantThing
			},
			Thing.isKit(thing) && isOwnProfile && isCreator && {
				name: this.context.translate('Delete'),
				handler: deleteKit
			},
			Thing.isKit(thing) && isOwnProfile && isCreator && {
				name: this.context.translate('Edit'),
				handler: editKit
			}
		].filter(val => !!val)

		const collectionProps = {
			itemImageClassName: styles.thingImage,
			itemTitle: Thing.title,
			itemSubtitle: Thing.subtitle,
			itemImageContent: Thing.images,
			itemIconName: thingIconName,
			itemHref: Thing.href,
			itemOnSelect: openThing
		}

		const createKit = () => this.props.appRedirect('/kit/edit')

		const renderNoThings = (hasLoadedThings, action, message, ownProfileMessage) => () => {
			const renderMessage = () => (isOwnProfile ? (
				<Button onClick={action}>
					{ownProfileMessage}
				</Button>
			) : (
				<div>{message}</div>
			))

			return (
				<div>
					{hasLoadedThings ? renderMessage() : <LoadingInline />}
				</div>
			)
		}

		return (
			<div>
				<ExpandableSection title={userProfileKits ? this.context.translate('{kits|# - Kit|# - Kits}', { kits: getField(userProfile, 'countKitsCreated') || 0 }) : this.context.translate('Kits')} defaultExpanded>
					<Collection
						items={userProfileKits}
						contextMenuItems={kit => contextMenuItems(kit, { isCreator: true })}
						{...collectionProps}
						renderWhenNoItems={renderNoThings(loadedKits, createKit, <div className={styles.noPosts}>{this.context.translate('No Kits')}</div>, this.context.translate('No Kits yet - Click here to create one'))}
					/>
				</ExpandableSection>
				<ExpandableSection title={ownedThings ? this.context.translate('{count} - Own', { count: ownedThings.length }) : this.context.translate('Own')} defaultExpanded>
					<Collection
						items={ownedThings}
						contextMenuItems={thing => contextMenuItems(thing, { isOwned: true })}
						{...collectionProps}
						renderWhenNoItems={renderNoThings(loadedOwnedThings, openSearch, <div className={styles.noPosts}>{this.context.translate('No Kits or Items owned')}</div>, this.context.translate('No Kits or Items owned yet - Click here to search for some'))}
					/>
				</ExpandableSection>
				<ExpandableSection title={wantedThings ? this.context.translate('{count} - Want', { count: wantedThings.length }) : this.context.translate('Want')} defaultExpanded>
					<Collection
						items={wantedThings}
						contextMenuItems={thing => contextMenuItems(thing, { isWanted: true })}
						{...collectionProps}
						renderWhenNoItems={renderNoThings(loadedWantedThings, openSearch, <div className={styles.noPosts}>{this.context.translate('No Kits or Items wanted')}</div>, this.context.translate('No Kits or Items wanted yet - Click here to search for some'))}
					/>
				</ExpandableSection>
			</div>
		)
	}
}

UserKit.contextTypes = {
	translate: PropTypes.func
}

UserKit.propTypes = {
	isOwnProfile: PropTypes.bool,
	userProfile: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	userProfileKits: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	userProfileKitsOwned: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	userProfileKitsWanted: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	userProfileItemsOwned: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	userProfileItemsWanted: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	appRedirect: PropTypes.func.isRequired,
	kitDuplicate: PropTypes.func.isRequired,
	kitDelete: PropTypes.func.isRequired,
	kitOwnSet: PropTypes.func.isRequired,
	kitWantSet: PropTypes.func.isRequired,
	itemOwnSet: PropTypes.func.isRequired,
	itemWantSet: PropTypes.func.isRequired
}

UserKit.defaultProps = {
	isOwnProfile: false,
	userProfile: undefined,
	userProfileKits: undefined,
	userProfileKitsOwned: undefined,
	userProfileKitsWanted: undefined,
	userProfileItemsOwned: undefined,
	userProfileItemsWanted: undefined
}

export default UserKit



// WEBPACK FOOTER //
// ./src/components/User/Kit.jsx